import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBurgerIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.5 5H17.5M2.5 10H17.5M2.5 15H17.5",
		stroke: "#EFEEF0",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgBurgerIcon;
